import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '../../../product/components/templates/Layout'
import DropdownManage from '../../../product/views/Dynamic/dropdown'
const BusinessCategory = () => {
    return (
        <Layout>
            <div className="dashboard staticPages">
                <DropdownManage
                    name={'category'}
                    subLevel={0}
                    subField={null}
                />
            </div>
        </Layout>
    )
}
export default BusinessCategory
